import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { mixpanel, snowplow, constants } from 'common/helpers'

import { Box } from 'components/_new/layout'
import Modal from 'components/modal/Modal/Modal'
import Text from 'components/_new/typography/Text/Text'

import AddressesForm from './AddressesForm/AddressesForm'

import messages from './messages'
import s from './AddressValidationModal.scss'

// TODO legacy, used in old cardUpdate and old payment, remove after recurly - added on 15.07.2020 by sonatskiy
class AddressValidationModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    data: PropTypes.shape({
      paymentType: PropTypes.string,
      paymentMethod: PropTypes.string,
      values: PropTypes.object,
      recommendValues: PropTypes.object,
      enteredValues: PropTypes.object,
      payPalBeginAction: PropTypes.func,
      payPalCommitAction: PropTypes.func,
      payPalOnSuccess: PropTypes.func,
      handlerAddressVerification: PropTypes.func,
      placement: PropTypes.string,
    }),
  }

  static defaultProps = {
    name: constants.modals.AddressValidation,
  }

  componentDidMount() {
    const { data: { paymentMethod } } = this.props

    snowplow.track(constants.snowplowEvents.addressValidationPopup.open, {
      paymentMethod,
    })
  }

  handleClose = () => {
    const { name, onClose } = this.props

    mixpanel.track(constants.analyticsEvents.addressValidationPopup.close)
    actions.models.modals.close(name)

    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name, data } = this.props
    const {
      paymentType, values, enteredValues, recommendValues, payPalOnSuccess,
      handlerAddressVerification, placement, isEnoughVindiciaCreditsToBuy,
      payPalBeginAction, payPalCommitAction,
    } = data

    const description = recommendValues.isFailed ? messages.addressNotFound : messages.wrongAddress

    return (
      <Modal
        className={s.addressVerificationModal}
        name={name}
        title={messages.title}
        onClose={this.handleClose}
        titleUppercase
        id="addressVerificationModal"
      >
        <Box alignLeft>
          <Text className={s.description} message={description} html />
          <AddressesForm {...{
            paymentType,
            values,
            enteredValues,
            recommendValues,
            payPalBeginAction,
            payPalCommitAction,
            payPalOnSuccess,
            placement,
            isEnoughVindiciaCreditsToBuy,
            onSubmit: handlerAddressVerification,
          }} />
        </Box>
      </Modal>
    )
  }
}


export default AddressValidationModal
